import { Experiment, LifeInsuranceSimplifiedOffers, withExperiment } from 'embed/experiments'
import { LifeInsuranceStep } from 'even-ts-static'
import * as React from 'react'

import { ConnectedStepbystepApplicationContainer as ApplicationStep } from './Application/container'
import { PersonalInfoConfirmation, RequestACallConfirmation } from './common/Confirmation'
import { ConnectedLifeInsurancePersonalInfoContainer as PersonalInfoStep } from './PersonalInfo/container'
import { PreviewStep } from './Preview'
import { RequestACall } from './RequestACall/index'
import { LifeInsuranceResultsContainer } from './Results/container'

interface OwnProps {
  selectedStep: LifeInsuranceStep
}

export const LifeInsuranceView = ({ selectedStep }: OwnProps) => {
  switch (selectedStep) {
    case LifeInsuranceStep.Application: {
      return <ApplicationStep />
    }
    case LifeInsuranceStep.Results: {
      return <LifeInsuranceResultsContainer />
    }
    case LifeInsuranceStep.PersonalInfo: {
      return <PersonalInfoStep />
    }
    case LifeInsuranceStep.PersonalInfoConfirmation: {
      return <PersonalInfoConfirmation />
    }
    case LifeInsuranceStep.RequestACall: {
      return <RequestACall />
    }
    case LifeInsuranceStep.RequestACallConfirmation: {
      return <RequestACallConfirmation />
    }
    case LifeInsuranceStep.Preview:
    default: {
      return <PreviewStep />
    }
  }
}

const LifeInsuranceViewExperiment = ({ selectedStep }: OwnProps) => (
  <Experiment experiment={LifeInsuranceSimplifiedOffers}>
    <LifeInsuranceView selectedStep={selectedStep} />
  </Experiment>
)

export const LifeInsuranceViewWithExperiment = withExperiment(LifeInsuranceSimplifiedOffers)(
  LifeInsuranceViewExperiment,
)
